/**
 * Spanish Quote Translations
 * 报价弹窗翻译模块 - 西班牙语
 * 
 * 包含获取报价表单和弹窗等翻译
 */

import type { QuoteTranslations } from '../../types';

export const esQuote: QuoteTranslations = {
  getQuote: 'Obtener Cotización',
  title: 'Obtén una Cotización Gratis',
  modal: {
    title: 'Obtén una Cotización Gratis',
    subtitle: 'Complete los detalles a continuación y nuestro equipo le responderá en 24 horas.',
    fullName: 'Nombre Completo',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    productInterest: 'Producto de Interés',
    message: 'Mensaje',
    placeholderName: 'Juan Pérez',
    placeholderEmail: 'juan@example.com',
    placeholderPhone: '+34 600 000 000',
    placeholderProduct: 'ej., Calefactor Industrial',
    placeholderMessage: 'Detalles del proyecto, cantidad, requisitos de voltaje...',
    submit: 'Enviar Solicitud',
    successTitle: '¡Solicitud Recibida!',
    successMessage: 'Gracias por su interés. Uno de nuestros especialistas en calefacción revisará sus requisitos y se comunicará con usted en breve.',
    close: 'Cerrar',
  },
  name: 'Su Nombre',
  email: 'Dirección de Correo Electrónico',
  phone: 'Número de Teléfono',
  company: 'Nombre de la Empresa',
  message: 'Mensaje',
  submit: 'Enviar Solicitud',
  success: '¡Gracias! Nos pondremos en contacto con usted pronto.',
};
